import { ABORT_TRIP_STATUSES } from '@chukua/common';

/** The office can abort a trip from dispatch until the goods are handed over; the server enforces the same list. */
export function canOfferAbort(tripStatus: string, canDispatch: boolean): boolean {
  return canDispatch && (ABORT_TRIP_STATUSES as readonly string[]).includes(tripStatus);
}
